import { reactive } from 'vue'

export interface Toast {
  id: number
  type: 'success' | 'error'
  message: string
}

const state = reactive<{ toasts: Toast[] }>({ toasts: [] })
let nextId = 0

export function useToast () {
  function show (type: Toast['type'], message: string, duration = 4000) {
    const id = ++nextId
    state.toasts.push({ id, type, message })
    setTimeout(() => dismiss(id), duration)
  }

  function dismiss (id: number) {
    const i = state.toasts.findIndex(t => t.id === id)
    if (i !== -1) state.toasts.splice(i, 1)
  }

  const success = (message: string) => show('success', message)
  const error = (message: string) => show('error', message)

  return { toasts: state.toasts, success, error, dismiss }
}
